import { gql } from '@apollo/client';

export const SCHOOL = gql`
  query school($id: ID!) {
    school(id: $id) {
      id
      name
      conference
      manConference
      womanConference
      itaRegion
      rankingAwardRegion
      ustaSection
      manId
      womanId
      division
      mailingAddress
      city
      state
      zipCode
      teamType
    }
  }
`;
